import React, { useRef, useState, useCallback, useEffect, useContext } from 'react';
import { Popup } from '@progress/kendo-react-popup';
import { translate } from '@utils/i18n';
import { Button } from '@ui';
import useTenantContext from '@contexts/useTenantContext';
import useModalContext from '@contexts/useModalContext';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore — routes module resolved by webpack alias
import { newInspectionPath, newWorkOrderPath } from 'routes';
import { CalendarContext } from '../CalendarContext';
import { GenericEventType, GenericEventIcon } from '../constants';
const namespace = 'features.calendar.create_event';
function CreateEvent({ withTitle = false }) {
    var _a;
    const { permissions } = useContext(CalendarContext);
    const { tenant } = useTenantContext();
    const { openNewGenericEventModal } = useModalContext();
    const anchor = useRef(null);
    const popup = useRef(null);
    const [open, setOpen] = useState(false);
    const handleBodyClick = useCallback((event) => {
        var _a, _b, _c;
        // eslint-disable-next-line no-underscore-dangle
        if ((_b = (_a = popup.current) === null || _a === void 0 ? void 0 : _a._popup) === null || _b === void 0 ? void 0 : _b.contains(event.target))
            return;
        if ((_c = anchor.current) === null || _c === void 0 ? void 0 : _c.contains(event.target))
            return;
        setOpen(false);
    }, []);
    useEffect(() => {
        document.body.addEventListener('click', handleBodyClick);
        return () => {
            document.body.removeEventListener('click', handleBodyClick);
        };
    }, []);
    const onAddEventPopup = useCallback(() => {
        setOpen((prev) => !prev);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Popup, { anchor: anchor.current, show: open, ref: popup },
            React.createElement("div", { className: "qmb-popup--action-list" },
                React.createElement("ul", { role: "presentation" },
                    React.createElement("li", { key: "inspection" },
                        React.createElement("a", { href: newInspectionPath(), style: { cursor: 'pointer' } },
                            React.createElement("i", { className: "fa-light fa-clipboard-check" }),
                            translate('inspection', { namespace }))),
                    permissions.hasService && (React.createElement("li", { key: "wo" },
                        React.createElement("a", { href: newWorkOrderPath(), style: { cursor: 'pointer' } },
                            React.createElement("i", { className: "fa-light fa-screwdriver-wrench" }),
                            translate('work_order', { namespace }))))),
                ((_a = tenant === null || tenant === void 0 ? void 0 : tenant.flags) === null || _a === void 0 ? void 0 : _a.enableGenericEvents) && (React.createElement(React.Fragment, null,
                    React.createElement("hr", { className: "popup__split" }),
                    React.createElement("div", { className: "popup__section--group" },
                        React.createElement("h4", { className: "popup__section-title--small" }, translate('generic_event', { namespace })),
                        React.createElement("ul", { role: "presentation" }, Object.values(GenericEventType).map((eventType) => (React.createElement("li", { key: eventType },
                            React.createElement("button", { type: "button", className: "qmb-control", onClick: () => {
                                    openNewGenericEventModal({ eventType });
                                    onAddEventPopup();
                                } },
                                React.createElement("i", { className: GenericEventIcon[eventType] }),
                                translate(eventType, { namespace }))))))))))),
        withTitle && (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        React.createElement(Button, { isMenu: true, ref: anchor, disabled: !permissions.createEvent, onClick: onAddEventPopup },
            React.createElement("i", { className: "fa-light fa-circle-plus" }),
            translate('create', { namespace }))),
        !withTitle && (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        React.createElement(Button, { isMenu: true, ref: anchor, disabled: !permissions.createEvent, onClick: onAddEventPopup },
            React.createElement("i", { className: "fa-light fa-circle-plus" })))));
}
export default CreateEvent;
